/**
 * Generated by orval 🍺
 * Do not edit manually.
 * User Management Users API
 * UserManagement bounded-context contract for user administration.
 * OpenAPI spec version: 1.0.0
 */
import type {
  InviteUserRequest,
  ListUserManagementUsersParams,
  PaginatedUserDto,
  UpdateUserProfileRequest,
  UserDto,
} from "../model";

import {customFetch} from "../../../runtime/custom-fetch";

export const getListUserManagementUsersUrl = (params: ListUserManagementUsersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/user-management/users?${stringifiedParams}`
    : `/api/v1/user-management/users`;
};

/**
 * @summary List users
 */
export const listUserManagementUsers = async (
  params: ListUserManagementUsersParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<PaginatedUserDto> => {
  return customFetch<PaginatedUserDto>(getListUserManagementUsersUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getInviteUserManagementUserUrl = () => {
  return `/api/v1/user-management/users`;
};

/**
 * @summary Invite user
 */
export const inviteUserManagementUser = async (
  inviteUserRequest: InviteUserRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<string> => {
  return customFetch<string>(getInviteUserManagementUserUrl(), {
    ...options,
    method: "POST",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(inviteUserRequest),
  });
};

export const getActivateCurrentUserManagementUserUrl = () => {
  return `/api/v1/user-management/users/me/activate`;
};

/**
 * @summary Activate current user
 */
export const activateCurrentUserManagementUser = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getActivateCurrentUserManagementUserUrl(), {
    ...options,
    method: "POST",
  });
};

export const getGetUserManagementUserUrl = (id: string) => {
  return `/api/v1/user-management/users/${id}`;
};

/**
 * @summary Get user
 */
export const getUserManagementUser = async (
  id: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<UserDto> => {
  return customFetch<UserDto>(getGetUserManagementUserUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getResendUserManagementInvitationUrl = (id: string) => {
  return `/api/v1/user-management/users/${id}/resend-invitation`;
};

/**
 * @summary Resend user invitation
 */
export const resendUserManagementInvitation = async (
  id: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<string> => {
  return customFetch<string>(getResendUserManagementInvitationUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getSuspendUserManagementUserUrl = (id: string) => {
  return `/api/v1/user-management/users/${id}/suspend`;
};

/**
 * @summary Suspend user
 */
export const suspendUserManagementUser = async (
  id: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getSuspendUserManagementUserUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getReactivateUserManagementUserUrl = (id: string) => {
  return `/api/v1/user-management/users/${id}/reactivate`;
};

/**
 * @summary Request user reactivation
 */
export const reactivateUserManagementUser = async (
  id: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getReactivateUserManagementUserUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getUpdateUserManagementProfileUrl = (id: string) => {
  return `/api/v1/user-management/users/${id}/profile`;
};

/**
 * @summary Update user profile
 */
export const updateUserManagementProfile = async (
  id: string,
  updateUserProfileRequest: UpdateUserProfileRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getUpdateUserManagementProfileUrl(id), {
    ...options,
    method: "PUT",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(updateUserProfileRequest),
  });
};
